import React from "react";
import { CardChecklist, PatchQuestion } from "react-bootstrap-icons";

import Utils from "../../../Utils";

const BooleanCell = ({ props }) => {
  const { data, colIndex, schema, tableColumns } = props;
  let textValue = data[colIndex];

  let IconRender = null;
  let isQuiz = false;
  if (schema && schema?.key) {
    const key = schema?.key;
    let isQuizColIndex = tableColumns?.indexOf(key);
    isQuiz = data[isQuizColIndex] || false;
    IconRender = isQuiz ? PatchQuestion : CardChecklist;
  }
  let extraClassNames =
    textValue === Utils.APP_CONSTANTS.DOUBLE_TICK
      ? "indi-double-tick-mark"
      : "";
  let checkedText = !!textValue;
  return (
    <>
      {checkedText && (
        <div className={`indi-tick-mark ${extraClassNames}`}></div>
      )}
      {IconRender && (
        <span className="indi-boolean-icon-cell">
          <IconRender size={18} title={isQuiz ? "Quiz" : "Assessment"} />
        </span>
      )}
    </>
  );
};

export default BooleanCell;
